import React from "react";

const LoadingState = ({ message = "Working on it..." }) => {
    return (
        <div className="w-full min-h-screen flex flex-col items-center justify-center">

            {/* Spinner */}
            <div className="w-12 h-12 border-4 border-gray-300 border-t-lime-700 rounded-full animate-spin"></div>

            {/* Message */}
            <p className="mt-4 text-gray-600 text-lg font-medium">
                {message}
            </p>
        </div>
    );
};

export default LoadingState;
